import interconnectivityApi from '@/api/interconnectivity';
import {mutationTypes} from '@/store/modules/interconnectivity/mutations';

export const actionsTypes = {
  getAvailability: '[interconnectivity] get availability',
  getAvailabilityExport: '[interconnectivity] get availability export',
  getInterconnectivity: '[interconnectivity] get interconnectivity',
};

const actions = {
  [actionsTypes.getAvailability](context, {companyId, params}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getAvailabilityStart);
      interconnectivityApi
        .getAvailability(companyId, params)
        .then((response) => {
          context.commit(mutationTypes.getAvailabilitySuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getAvailabilityFailure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.getAvailabilityExport](context, {companyId, params}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getAvailabilityExportStart);
      interconnectivityApi
        .getAvailabilityExport(companyId, params)
        .then((response) => {
          context.commit(mutationTypes.getAvailabilityExportSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getAvailabilityExportFailure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.getInterconnectivity](context, {companyId, params}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getInterconnectivityStart);
      interconnectivityApi
        .getInterconnectivity(companyId, params)
        .then((response) => {
          context.commit(mutationTypes.getInterconnectivitySuccess, response.data);
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.getInterconnectivityFailure, result.response.data.message);
          reject(result);
        });
    });
  },
};

export default actions;
